import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { routes } from '../../../redux/api/routes';
import {
	getOrderDetails,
	saveOrderDetails,
	saveOriginalOrderDetails
} from '../../../redux/actions';

const {  ncrpData} = routes;

class ApproveNcrpForm extends Component {

    constructor(props) {
        super(props);
        this.state={
            approveNcrpDetails:[]
        }
    }

    componentWillMount() {
		const self = this;
		self.props.getOrderDetails(`accountNumber=${ncrpData.accountNumber}`+`&poNumber=${self.props.getSelectedAccountNumber()}-NCRP`+'&requestType=manageOrders&orderSource=NCRP&orderStatus=ENTERED', (response) => {
          this.setState({
            approveNcrpDetails : response
          })
        });
	}

    updateStateAndSort(approveReturnsList) {
        const self = this;
        approveReturnsList.responseObject = approveReturnsList.responseObject.filter(itm =>
            itm.orderHeader.orderSourceRef.indexOf('CTN') === 0 &&
            (!itm.orderHeader.holds || !itm.orderHeader.holds.hold || itm.orderHeader.holds.hold.length === 0) &&
            itm.orderDetail.orderLine.find(item => item.userItemDescription) &&
            itm.orderHeader.orderSource === 'CustomerNet'
             // && itm.orderHeader.attributes && itm.orderHeader.attributes.attribute.find(it => it.name === 'Attribute13' && it.value && it.value.toUpperCase() === 'NO')
        );
        self.setState({
            approveReturnsList
        }, () => {
            self.handleSortBy({ target: { value: self.state.sortBy } });
        });
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleSortBy(event) {
        let sortBy = event.target.value.split(',')[0],
            sortOrder = event.target.value.split(',')[1],
            { approveReturnsList } = this.state,
            isAnyDateFilter = sortBy.indexOf('Date') !== -1;
        var self = this;
        approveReturnsList.responseObject = _.orderBy(approveReturnsList.responseObject, (e) => {
            return !isAnyDateFilter?e.orderHeader[sortBy]:self.props.formatDate(e.orderHeader[sortBy], 'MM/DD/YY')
        }, [sortOrder]);
        this.setState({
            sortBy: event.target.value,
            approveReturnsList,
        }, () => {
             // self.props.saveRequestReturnList(JSON.parse(JSON.stringify(approveReturnsList)));
        });
    }
    handleFetchOrderDetails(orderNumber, originalOrderNumber, wheretoRedirect, event) {
        event.preventDefault();
        const self = this;
        self.setState({
            orderNumberGetDetailsCallCompleted: false,
            originalOrderNumberGetDetailsCallCompleted: false,
        }, () => {
            self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderDetails&accountNumber='+ncrpData.accountNumber, (response) => {
                if(!response.status) {
                    self.setState({
                        errorMessage: response.responseMessage
                    })
                } else {
                    self.setState({
                        originalOrderNumberGetDetailsCallCompleted: true,
                        originalOrderNumberDetails: response,
                    }, () => {
                        self.saveAndRedirect(wheretoRedirect);
                    });
                }
            }, false);
            self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderDetails&accountNumber='+ncrpData.accountNumber, (response) => {
                if(!response.status) {
                    self.setState({
                        errorMessage: response.responseMessage
                    });
                } else {
                    const {
                        deliveryInstructions,
                    } = response.responseObject;
                    // if deliveryInstructions and it's starting from CreditOrderRef:CTN then current order is rebill order
                    if(deliveryInstructions && deliveryInstructions.indexOf('CreditOrderRef:CTN') === 0) {
                        // current details are of rebill order details
                        self.setState({
                            rebillOrderDetails: response,
                            errorMessage: '',
                        }, () => {
                            const referenceNumber = deliveryInstructions.replace('CreditOrderRef:', '');
                            self.fetchOtherOrderDetails('page=approveReturns&referenceNumber='+referenceNumber+'&requestType=getOrderDetails&accountNumber='+ncrpData.accountNumber, (resp) => {
                                if(resp.status && resp.responseObject) {
                                    const creditOrderDetails = {
                                        ...resp,
                                        responseObject: {
                                            ...resp.responseObject,
                                            rebillOrderDetails: self.state.rebillOrderDetails.responseObject,
                                        }
                                    };
                                    self.setState({
                                        orderNumberGetDetailsCallCompleted: true,
                                        orderNumberDetails: creditOrderDetails,
                                    }, () => {
                                        self.saveAndRedirect(wheretoRedirect);
                                    });
                                } else {
                                    self.setState({
                                        errorMessage: 'Error occured while fetching order details.'
                                    });
                                }
                            });
                        });
                    }
                    // else // if deliveryInstructions and it's starting from RebillOrderRef:CTN then current order is credit order
                    else if (deliveryInstructions && deliveryInstructions.indexOf('RebillOrderRef:CTN') === 0) {
                        // current details are of credit order details
                        self.setState({
                            creditOrderDetails: response,
                            errorMessage: '',
                        }, () => {
                            const referenceNumber = deliveryInstructions.replace('RebillOrderRef:', '');
                            self.fetchOtherOrderDetails('page=approveReturns&referenceNumber='+referenceNumber+'&requestType=getOrderDetails&accountNumber='+ncrpData.accountNumber, (resp) => {
                                if(resp.status && resp.responseObject) {
                                    const creditOrderDetails = {
                                        ...self.state.creditOrderDetails,
                                        responseObject: {
                                            ...self.state.creditOrderDetails.responseObject,
                                            rebillOrderDetails: resp.responseObject,
                                        }
                                    };
                                    self.setState({
                                        orderNumberGetDetailsCallCompleted: true,
                                        orderNumberDetails: creditOrderDetails,
                                    }, () => {
                                        self.saveAndRedirect(wheretoRedirect);
                                    });
                                } else {
                                    self.setState({
                                        errorMessage: 'Error occured while fetching order details.'
                                    });
                                }
                            });
                        });
                    }
                    // else its normal order
                    else {
                        self.setState({
                            orderNumberGetDetailsCallCompleted: true,
                            orderNumberDetails: response,
                        }, () => {
                            self.saveAndRedirect(wheretoRedirect);
                        });
                    }
                }
            }, false);
        });


    }

    saveAndRedirect(wheretoRedirect) {
        const self = this;
        const { orderNumberDetails, originalOrderNumberDetails, orderNumberGetDetailsCallCompleted, originalOrderNumberGetDetailsCallCompleted } = self.state;
        if (orderNumberGetDetailsCallCompleted === originalOrderNumberGetDetailsCallCompleted) {
            // update details with invoice number details from original order number details
            const originalItems = originalOrderNumberDetails.responseObject.items;
            self.props.saveOriginalOrderDetails(originalItems)
            orderNumberDetails.responseObject.items.forEach((item) => {
                const originalItem = originalItems.find(itm => itm.invoiceNumber === item.originalInvoiceNumber);
                const originalItemMatch = originalItems.find(itm => itm.item === item.item);
                //originalItemMatch && self.props.saveOriginalOrderDetails(originalItemMatch)
                if (originalItem && originalItem.invoiceDate) {
                    item.invoiceDate = this.props.formatDate(originalItem.invoiceDate, 'MM/DD/YY');
                }
            });
            self.props.saveOrderDetails(orderNumberDetails);
            browserHistory.push('/' + wheretoRedirect);
        }
    }

    fetchOtherOrderDetails(queryString, callback) {
        const self = this;
        // make below line for order reference number
        self.props.getOrderDetails(queryString, (resp) => {
            if(!resp.status) {
                self.setState({
                    errorMessage: resp.responseMessage
                })
            } else {
                callback(resp);
            }
        });
    }

    render() {
        const {
            approveNcrpDetails,
            errorMessage,
        } = this.state;
        const sortedRows = approveNcrpDetails && approveNcrpDetails.status && approveNcrpDetails.responseObject.length > 0
            ? approveNcrpDetails.responseObject
                .slice()
                .sort((a, b) => b.orderHeader.orderNumber - a.orderHeader.orderNumber)
            : [];
        return (
            <div>
                <div className="push d-none d-sm-block">
                    <h1 className="pageTitle">Approve NCRP</h1>
                </div>
                <div className="push d-block d-sm-none m-3">
                    <h1 className="pageTitle">Approve NCRP</h1>
                </div>
                {errorMessage && <p className="bold red">{errorMessage}</p>}
                <div className="push d-none d-sm-block">
                    <div className="captionAboveTable">
                        <div className="columns">
                            <div className="column column1">
                                <big className="bold">{approveNcrpDetails && approveNcrpDetails.status && approveNcrpDetails.responseObject.length} NCRP Requests
                                </big>
                            </div>
                        </div>
                    </div>
                    <table className="dataTable viewReturnsTable">
                        <thead>
                            <tr>
                                <th className="orderNumber">CSO</th>
                                <th className="orderRef">Order Reference #</th>
                                <th className="purchaseOrderr">PO</th>
                                <th className="orderedBy">Ordered By</th>
                                <th className="dateEntered">Date Entered</th>
                                <th className="returnStatus">Status</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {approveNcrpDetails && approveNcrpDetails.status && approveNcrpDetails.responseObject.length === 0
                                ? <tr>
                                    <td colSpan={7}>No orders found meeting the specified criteria; please try your search again.</td>
                                  </tr>
                                : null
                            }
                            {sortedRows.map((item, index) => {
                                let { orderHeader } = item,
                                    { orderLine } = item.orderDetail,
                                    enteredBy = "",
                                    { attribute } = orderHeader.attributes;
                                attribute = attribute ? _.find(attribute, ['name', 'Attribute2']) : null;
                                if (attribute) { enteredBy = attribute.value; }
                                let originalOrderNumber = '';
                                if (orderLine && orderLine.length) {
                                    orderLine.forEach(v => {
                                        if (v.returnAttribute1 && v.returnAttribute1 != undefined) {
                                            originalOrderNumber = v.returnAttribute1;
                                        }
                                    });
                                }
                                let orderHeaderValue = '';
                                if (orderHeader && orderHeader.attributes && orderHeader.attributes.attribute) {
                                    const attr2 = orderHeader.attributes.attribute.find(attr => attr.name === 'Attribute2');
                                    orderHeaderValue = attr2 ? attr2.value : '';
                                }
                                return (<tr key={index}>
                                        <td className="returnNumber">{orderHeader.orderNumber}</td>
                                        <td>{orderHeader.orderSourceRef}</td>
                                        <td className="enteredBy">{orderHeader.ponumber}</td>
                                        <td><td>{orderHeaderValue}</td></td>
                                        <td className="dateEntered">{this.props.formatDate(orderHeader.createdDate, 'MM/DD/YY')}</td>
                                        <td className="returnStatus">{orderHeader.orderStatus}</td>
                                        <td className="textCenter">
                                            <a href="#" onClick={this.handleFetchOrderDetails.bind(this, orderHeader.orderNumber, originalOrderNumber, 'approvencrporderdetails')}>
                                                Review</a>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                {/* MOBILE VIEW  (visible only on xs)*/}
                <div className="d-block d-sm-none m-3">
                    <p className="bold">
                        {approveNcrpDetails && approveNcrpDetails.status && approveNcrpDetails.responseObject.length} NCRP Requests
                    </p>

                    {approveNcrpDetails && approveNcrpDetails.status && approveNcrpDetails.responseObject.length === 0 && (
                        <p>No orders found meeting the specified criteria; please try your search again.</p>
                    )}

                    {sortedRows.map((item, index) => {
                        let { orderHeader } = item,
                            { orderLine } = item.orderDetail;

                        let originalOrderNumber = '';
                        if (orderLine && orderLine.length) {
                            orderLine.forEach(v => {
                                if (v.returnAttribute1 && v.returnAttribute1 != undefined) {
                                    originalOrderNumber = v.returnAttribute1;
                                }
                            });
                        }

                        let orderHeaderValue = '';
                        if (orderHeader && orderHeader.attributes && orderHeader.attributes.attribute) {
                            const attr2 = orderHeader.attributes.attribute.find(attr => attr.name === 'Attribute2');
                            orderHeaderValue = attr2 ? attr2.value : '';
                        }

                        return (
                            <div key={index} className="card mb-3 p-3" style={{ border: '1px solid #ddd', borderRadius: '4px' }}>
                                <div className="mb-1">
                                    <span className="bold">CSO: </span>{orderHeader.orderNumber}
                                </div>
                                <div className="mb-1">
                                    <span className="bold">Order Reference #: </span>{orderHeader.orderSourceRef}
                                </div>
                                <div className="mb-1">
                                    <span className="bold">PO: </span>{orderHeader.ponumber}
                                </div>
                                <div className="mb-1">
                                    <span className="bold">Ordered By: </span>{orderHeaderValue}
                                </div>
                                <div className="mb-1">
                                    <span className="bold">Date Entered: </span>{this.props.formatDate(orderHeader.createdDate, 'MM/DD/YY')}
                                </div>
                                <div className="mb-1">
                                    <span className="bold">Status: </span>{orderHeader.orderStatus}
                                </div>
                                <div className="mt-2">
                                    <a href="#" onClick={this.handleFetchOrderDetails.bind(this, orderHeader.orderNumber, originalOrderNumber, 'approvencrporderdetails')}>
                                        Review
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderDetails: (queryStringParams, callback, saveToStore) => dispatch(getOrderDetails(queryStringParams, callback, saveToStore)),
	saveOrderDetails: (data) => dispatch(saveOrderDetails(data)),
	saveOriginalOrderDetails: (data) => dispatch(saveOriginalOrderDetails(data)),
});

ApproveNcrpForm = connect(mapStateToProps, mapDispatchToProps)(ApproveNcrpForm);
export default ApproveNcrpForm;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/ApproveNcrpForm.jsx